import type { ReactNode } from "react"
import { createElement } from "react"
import { Text } from "@ionos-web-design-system/react"
import type { Components } from "react-markdown"

const markdownOverrides: Components = {
  h1: ({ children }: { children: ReactNode }) =>
    createElement(
      Text,
      { asChild: true, variant: "heading4xl", weight: "black", color: "base" },
      createElement("h1", null, children)
    ),
  h2: ({ children }: { children: ReactNode }) =>
    createElement(
      Text,
      { asChild: true, variant: "heading3xl", weight: "black", color: "base" },
      createElement("h2", null, children)
    ),
  h3: ({ children }: { children: ReactNode }) =>
    createElement(
      Text,
      { asChild: true, variant: "heading3xl", weight: "black", color: "base" },
      createElement("h3", null, children)
    ),
} as Components

export default markdownOverrides
